import { baseFetch } from "@helium10/re-core";
import { InboundLink } from "@/core/apiLink";
import { getHeaderHelper } from "@/core/helpers/getHeader.helper";
import type { IInboundCommonResponse } from "@/features/inbound/requests";

/**
 * callbackResult 接口请求参数
 */
export interface ICallbackResultParams {
  accountId: string;
  batchId: string;
  filePath: string;
  fileHash: string;
  sellerId: string;
  shipmentId: string;
  storagePath: string;
  uploadResult: boolean; // true: 上传成功, false: 上传失败
  fileId: string;
}

/**
 * 调用 callbackResult 接口
 * 通知后端上传S3的行为动作已经结束
 */
export const callbackResult = async (params: ICallbackResultParams) => {
  return baseFetch<ICallbackResultParams, IInboundCommonResponse>({
    method: "POST",
    headers: getHeaderHelper(),
    useSessionAccountId: true,
    url: InboundLink.callbackResult,
    params,
  });
};
